// extracted by mini-css-extract-plugin
module.exports = {"passwordHeader":"password_passwordHeader__GmzLy","passwordSubtext":"password_passwordSubtext__8Exrv","passwordInputs":"password_passwordInputs__o6B3F"};